import {
  BrowserRouter as Router,
  Route,
  Switch as RouterSwitch,
} from 'react-router-dom'
import AccessRouter from './AccessRouter'

const AppRouter = () => (
  <Router>
    <RouterSwitch>
      <Route path='/event/:eventId' exact={true} component={AccessRouter} />
    </RouterSwitch>
  </Router>
)

export default AppRouter
